import { Component, OnInit } from '@angular/core';
import { VersionDTO } from '@osapp/modules/versions/services/versionDTO';
import { VersionsService } from '@osapp/modules/versions/services/versions.service';

@Component({
  selector: 'di-app-info',
  templateUrl: './app-info.page.html',
  styleUrls: ['./app-info.page.scss'],
})
export class AppInfoPage implements OnInit {

  public appVersion: string;
	public envType: string;
	public envVersion: string;
	public dateMAJ : string


  constructor(
    private svcVersion: VersionsService
  ) { }

  ngOnInit() {
    this.svcVersion.getVersionBack().subscribe({
			next: (infoEnv: VersionDTO) => {
				this.envVersion = infoEnv.version;
				this.envType = infoEnv.environment;
				this.appVersion = this.svcVersion.version;
				const buildDate = document.querySelector('meta[name="build-date"]')?.getAttribute('content');
				this.dateMAJ = buildDate ?? 'Inconnue';
			},
			error: (err) => {
				console.error('Erreur lors de la récupération de la version backend', err);
			}
		});
  }

}
